import React from 'react'

function ChartIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" id="show_chart_black_24dp" width="27.157" height="24" viewBox="0 0 27.157 24">
            <path id="Path_204962" data-name="Path 204962" d="M0,0H24V24H0Z" fill="none" />
            <path id="Path_204963" data-name="Path 204963" d="M3.5,18.49l6-6.01,4,4L22,6.92,20.59,5.51,13.5,13.48l-4-4L2,16.99Z" fill="#1b5984" />
            <path id="Path_204964" data-name="Path 204964" d="M10,6,8.59,7.41,13.17,12,8.59,16.59,10,18l6-6Z" transform="translate(3.116 7.257) rotate(-45)" fill="#1b5984" />
        </svg>
    )
}

export default ChartIcon